import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { api } from "../../api/api";
import { country_url } from "../../api/urls";
// import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { confirm_password } from "../../api/urls";

const ConfirmPassword = ({ onClose, setIsUnRegistered, otp }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  // const [countries, setCountries] = useState([]);
  // const [isCountriesLoading, setIsCountriesLoading] = useState(true);
  // const [defaultCountry, setDefaultCountry] = useState(null);
  const [showPassword, setShowPassword] = useState(true);
  const [ConfirmPassword, setConfirmPassword] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      // setIsCountriesLoading(true);
      try {
        const { data } = await api.get(country_url);
        // setCountries(data);
        const defaultCountryData = data.find(
          (country) => country.country_mobile_code === 91
        );
        if (defaultCountryData) {
          // setDefaultCountry(defaultCountryData);
          setSelectedCountryCode(defaultCountryData.country_mobile_code);
        }
      } catch (error) {
        toast.error("Failed to fetch country data. Please try again later.");
      } finally {
        // setIsCountriesLoading(false);
      }
    };
    fetchCountries();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);

    if (!selectedCountryCode) {
      toast.error("Please select a country code.");
      setLoading(false);
      return;
    }

    try {
      await api.post(confirm_password, {
        token: otp,
        password: watch("password"),
      });

      toast.success("Password changed successfully!");
      onClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 style={styles.title}>Password</h2>
      <form onSubmit={handleSubmit(onSubmit)} style={styles.form}>
        <Controller
          name="password"
          control={control}
          rules={{
            required: "Password is required",
            minLength: {
              value: 6,
              message: "Password must be at least 6 characters long",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Enter new password"
              type={showPassword ? "password" : "text"}
              fullWidth
              error={!!errors.password}
              helperText={errors.password?.message}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <Controller
          name="confirm_password"
          control={control}
          rules={{
            required: "Confirm password is required",
            validate: (value) =>
              value === watch("password") || "Passwords do not match",
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Confirm password"
              type={ConfirmPassword ? "password" : "text"}
              fullWidth
              error={!!errors.confirm_password}
              helperText={errors.confirm_password?.message}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setConfirmPassword(!ConfirmPassword)}
                      edge="end"
                      size="small"
                    >
                      {ConfirmPassword ? (
                        <EyeOff size={20} />
                      ) : (
                        <Eye size={20} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <motion.button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          style={styles.button}
          whileHover={{ scale: 1.05 }}
        >
          {loading ? "Signing Up..." : "Send"}
        </motion.button>
      </form>
      {/* </motion.div> */}
    </>
  );
};

const styles = {
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  errorText: {
    color: "red",
    textAlign: "center",
  },
  button: {
    background: "#000000",
    color: "#FFF",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
  },
};

export default ConfirmPassword;
